<template>
  <div class="page-list">
    <h2 class="content-title">
      {{ $t('共享数据设置') }}
    </h2>
    <lamp-tip />
    <div class="action-bar">
      <v-button status="primary" @click="createRule">
        <v-icon name="new" class="add_icon" /> <span>{{ $t('新建规则') }}</span>
      </v-button>
      <div class="group-list">
        <v-tip ref="edit" placement="top">
          <span>{{ $t('编辑') }}</span>
        </v-tip>
        <v-tip ref="delete" placement="top">
          <span>{{ $t('删除') }}</span>
        </v-tip>
        <v-popconfirm ref="first" :inline="true" status="warning" placement="bottom-end" clazz="delete-confirm"
          @confirm="handleConfirm"
>
          <div class="demo-popconfirm-first">
            <h3>{{ $t('删除规则"{name}"?', { name: ruleName }) }}</h3>
          </div>
          <span slot="confirm-text">{{ $t('删除') }}</span>
        </v-popconfirm>
        <v-table :data="data" :loading="pageLoading" :hoverLight="false">
          <v-table-column v-for="(item, index) in columnConfig" :key="item.columnKey + '-' + index"
            :column-key="item.columnKey" :label="$t(item.label)" :width="item.width" :rowspan="item.rowspan"
/>
          <v-table-column align="right" clazz="group-list__action" :width="70">
            <template slot="cell" slot-scope="props">
              <div class="cell-opt">
                <v-button type="link" kind="primary" @click.stop="editItem(props.row)">
{{ $t('编辑') }}
</v-button>
                <v-button v-popconfirm:first type="link" kind="primary" style="margin-left: 7px;"
                  @click.stop="calldelItemDialog(props.row)"
>
{{ $t('删除') }}
</v-button>
              </div>
            </template>
          </v-table-column>
          <template slot="nodata">
            <div class="empty-image customer-empty" />
            <p class="empty-title">
              {{ $t('尚未设置规则，请点选"+新建规则"开始创建') }}
            </p>
          </template>
        </v-table>
        <v-pagination v-show="pagination.total" class="group-list__pagination" :total="pagination.total"
          :index="pagination.index" :count="pagination.count" @change="paginationChange"
/>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import LampTip from '../../components/lamp-tip/index.vue';

const req = require.context('../../../../../../assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);
const columnConfig = {
  bo_name: {
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    label: '业务',
    columnKey: 'bo_name',
    width: 190,
    rowspan: true,
  },
  rules_name: {
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    label: '规则名',
    columnKey: 'rules_name',
    width: 300,
    rowspan: false,
  },
  owner: {
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    label: '被共享人',
    columnKey: 'owner',
    rowspan: false,
  },
};
export default {
  components: {
    LampTip,
  },
  data() {
    return {
      columnConfig,
      pageLoading: true,
      data: [],
      pagination: {
        total: 0,
        index: 1,
        count: 15,
      },
      deleteId: 0,
      ruleName: '',
    };
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.meta.refresh) {
        vm.paginationChange().then(() => {
          vm.pageLoading = false;
        });
      }
    });
  },

  mounted() {
    this.paginationChange().then(() => {
      this.pageLoading = false;
    });
  },

  methods: {
    createRule() {
      this.$router.push({ path: 'sharedData/create' });
    },
    paginationChange(index, count) {
      const current = index || 1;
      this.pageLoading = true;
      let newData = [];
      return new Promise((resolve, reject) => {
        this.$ajax
          .gatewayPost('/v1/sharedPrivilege/sharedRulesAll', {
            index: current,
            count: count || this.pagination.count,
          })
          .then(
            (res) => {
              const { bo_info: boInfo, rules, total } = res.data || {};
              const boInfoMap = {};
              let formatRuleArr = [];

              if (boInfo && boInfo.length) {
                boInfo.forEach((bItem) => {
                  const { bo_id: boId, name } = bItem || {};

                  if (boId) {
                    boInfoMap[boId] = name;
                  }
                });
              }

              if (rules && rules.length) {
                formatRuleArr = rules.map((rbItem) => {
                  const { rule_id: ruleId, bo_id: boId, name, owner } = rbItem || {};

                  return {
                    bo_name: boInfoMap[boId],
                    bo_id: boId,
                    rule_id: ruleId,
                    rules_name: name,
                    owner,
                  };
                });
              } else {
                formatRuleArr = [];
              }

              // res.bo_info.forEach(i => {
              //     const rs = res.rules.filter(p => p.bo_id === i.bo_id);
              //     if (rs && rs.length > 0) {
              //         const rsList = rs.map(s => {
              //             return {
              //                 bo_name: i.name,
              //                 bo_id: i.bo_id,
              //                 rule_id: s.rule_id,
              //                 rules_name: s.name,
              //                 owner: s.owner
              //             };
              //         });
              //         newData = [...newData, ...rsList];
              //     } else {
              //         newData.push({
              //             bo_name: i.name,
              //             bo_id: i.bo_id,
              //             rules_name: '',
              //             owner: ''
              //         });
              //     }
              // });

              newData = [...newData, ...formatRuleArr];
              newData = newData.filter(i => i.rules_name !== '');
              // console.log(newData);
              this.data = newData;

              // todo
              this.pagination.total = parseInt(total, 10);
              // this.pagination.total = 100;
              this.pagination.index = current;
              this.pagination.count = count;

              this.pageLoading = false;

              resolve(res);
            },
            (error) => {
              this.$message(error.message || this.$t('请求出错'), 'error');
              reject(error);
            },
          );
      });
    },
    editItem(row) {
      this.$refs.edit.hide();
      this.$router.push({ path: `sharedData/edit/${row.rule_id}` });
    },
    calldelItemDialog(row) {
      this.deleteId = row.rule_id;
      this.ruleName = row.rules_name;
    },
    handleConfirm() {
      this.$ajax
        .gatewayPost('/v1/sharedPrivilege/delSharedRule', {
          rule_id: this.deleteId,
        })
        .then((res) => {
          this.data.forEach((item, index) => {
            if (res.data.rule_id === item.rule_id) {
              this.data.splice(index, 1);
            }
          });
          this.$message(this.$t('删除成功'), 'success');
          this.paginationChange(this.pagination.index, this.pagination.count);
        });
    },
  },
};
</script>
<style lang="less">
@import './index.less';
</style>
